import { render, staticRenderFns } from "./FormRate.vue?vue&type=template&id=c82b277e&scoped=true&"
import script from "./FormRate.vue?vue&type=script&lang=js&"
export * from "./FormRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82b277e",
  null
  
)

export default component.exports